module.exports = __webpack_public_path__ + "vfn-assets/img/es-mx.2256c6cb.svg";